import { render, staticRenderFns } from "./OpenBalance.vue?vue&type=template&id=fb87d47c&scoped=true&"
import script from "./OpenBalance.vue?vue&type=script&lang=js&"
export * from "./OpenBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb87d47c",
  null
  
)

export default component.exports